import { render } from "./LicenseFailureDialog.vue?vue&type=template&id=50c2ab38&scoped=true"
import script from "./LicenseFailureDialog.vue?vue&type=script&lang=js"
export * from "./LicenseFailureDialog.vue?vue&type=script&lang=js"

import "./LicenseFailureDialog.vue?vue&type=style&index=0&id=50c2ab38&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c2ab38"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QSpinnerDots,QBtn,QIcon});
